enum EditHandleTypeEnum {
    START_POINT = 'START_POINT',
    END_POINT = 'END_POINT',
    DIMENSION_OFFSET = 'DIMENSION_OFFSET',
    POLYGON_VERTEX = 'POLYGON_VERTEX',
    RECTANGLE_CORNER = 'RECTANGLE_CORNER',
    CIRCLE_RADIUS = 'CIRCLE_RADIUS',
    EXTRUSION_DEPTH = 'EXTRUSION_DEPTH',
}

export default EditHandleTypeEnum;
